import { useConsent } from "../../consent/useConsent";
import { Mail, Phone } from "lucide-react";
import "./AppFooter.scss";

function InstagramBrandIcon({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
      <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
    </svg>
  );
}

function FacebookBrandIcon({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.5 8.5H16.8V5.4C16.4 5.3 15.3 5.2 14 5.2C11.3 5.2 9.5 6.8 9.5 9.8V12.5H6.5V16H9.5V21H13V16H15.8L16.2 12.5H13V10.1C13 9.1 13.3 8.5 14.5 8.5Z"
        fill="currentColor"
      />
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function AppFooter() {
  const { openSettings } = useConsent();

  return (
    <footer className="app-footer">
      <div className="app-footer__container">
        <div className="app-footer__top">
          <div className="app-footer__brand">
            <h2 className="app-footer__title">Kvalitná škola, o. z.</h2>
          </div>

          <div className="app-footer__contacts" aria-label="Kontaktné údaje">
            <a className="app-footer__contact" href="mailto:capoeira@capoeira.sk">
              <Mail className="app-footer__contact-icon" size={16} strokeWidth={2} aria-hidden="true" />
              <span>capoeira@capoeira.sk</span>
            </a>
            <a className="app-footer__contact" href="tel:+421903664688">
              <Phone className="app-footer__contact-icon" size={16} strokeWidth={2} aria-hidden="true" />
              <span>+421 903 664 688</span>
            </a>
            <a
              className="app-footer__contact"
              href="https://www.instagram.com/abada_capoeira_slovensko/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramBrandIcon className="app-footer__contact-icon" />
              <span>Instagram</span>
            </a>
            <a
              className="app-footer__contact"
              href="https://www.facebook.com/AbadaCapoeiraSlovakia/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookBrandIcon className="app-footer__contact-icon" />
              <span>Facebook</span>
            </a>
          </div>
        </div>

        <nav className="app-footer__links" aria-label="Právne informácie">
          <a
            href="/vseobecne-obchodne-podmienky"
            className="app-footer__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            VOP
          </a>
          <span className="app-footer__sep" aria-hidden="true">
            ·
          </span>
          <a
            href="/ochrana-osobnych-udajov"
            className="app-footer__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ochrana osobných údajov
          </a>
          <span className="app-footer__sep" aria-hidden="true">
            ·
          </span>
          <button
            className="app-footer__link app-footer__link--btn"
            onClick={openSettings}
          >
            Nastavenie cookies
          </button>
        </nav>
      </div>
    </footer>
  );
}

export default AppFooter;
